import { Component, Input } from '@builder.io/sdk';

import moleculeAccordionFields from 'molecules/Accordion/config';
import { moleculeHeadingFields } from 'molecules/Heading/config';
import sectionFields from 'molecules/Section/config';

const accordionFields = [
  {
    name: 'htmlId',
    type: 'string',
    defaultValue: 'accordion-section',
    helperText: 'Unique section ID for anchor linking (e.g., "faq", "accordion", etc.)',
  },
  ...moleculeHeadingFields,
  ...moleculeAccordionFields,
  ...sectionFields,
  {
    name: 'isBulletStandard',
    type: 'boolean',
    defaultValue: true,
    helperText: 'If enabled, to match Figma’s standard bullets. Disable to uses Prismatic’s custom bullets.',
  },
  {
    name: 'className',
    type: 'string',
    defaultValue: '',
    helperText: 'Optional class name for custom styling',
  },
] as const satisfies DeepReadonly<Input[]>;

const accordionConfig = {
  name: 'accordion',
  inputs: accordionFields,
} satisfies Component;

export type AccordionConfigProps = GenerateBuilder<typeof accordionFields>;

export default accordionConfig;
